import { Notification } from 'types'
import { getUserId, useQueryHandler } from 'utils'

//useNotification:
export const useNotification = () => useQueryHandler<Notification>({
    query: `
        query getNotification {
            getNotification {
                id
                type
                message
                description
            }
        }
    `,
    cacheKey: ['notification', getUserId()],
    onSuccess: json => json.data.getNotification
})
